import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check (C3/C4 Task 11) — INERT until REACT_APP_APPCHECK_RECAPTCHA_SITE_KEY
// is set (obtained from the Firebase console reCAPTCHA v3 registration). This
// lets us ship the code now and enable it in Phase 5 (monitor -> enforce)
// without a redeploy. A debug token (localhost dev) is enabled via
// REACT_APP_APPCHECK_DEBUG_TOKEN.
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey) {
  const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  if (debugToken) {
    // Firebase reads this global before initializeAppCheck to accept a dev token.
    (globalThis as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string }).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // Non-fatal: never let App Check init break app boot.
    console.warn("App Check init failed (non-fatal):", e);
  }
}

// Auto-detect long-polling: ad-blockers / privacy shields (Brave Shields, uBlock)
// frequently block Firestore's streaming WebChannel endpoints
// (/Listen|Write/channel -> ERR_BLOCKED_BY_CLIENT), which silently kills all
// reads/writes. Auto-detect falls back to a long-polling request pattern most
// blockers don't catch. (Not a cure-all: a blocker banning the whole
// firestore.googleapis.com domain still breaks — that needs Shields-off.)
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth(app);
export const storage = getStorage(app);
